import React from "react";

import WorkingIndicator from "./partials/working-indicator.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import PassActions from "../actions/PassActions";
import PassStore from "../stores/PassStore";

class Pass extends React.Component {
  constructor(props) {
    super(props);
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  static getStores() {
    return [PassStore];
  }

  static getPropsFromStores() {
    return {
      passes: PassStore.getState().passes
    };
  }

  componentWillMount() {
    PassActions.fetchOne(this.props.params.passId.toLowerCase());
  }

  componentWillReceiveProps(props) {
    let pass = PassStore.getPassById(props.params.passId.toLowerCase());
    if (pass) {
      let prefix = props.params.eventBucketId
        ? `/event_buckets/${props.params.eventBucketId}`
        : "";
      if (pass.person && pass.person.id) {
        setTimeout(
          () =>
            this.context.router.replace({
              pathname: `${prefix}/people/${pass.person.id}`,
              query: { highlight_pass: pass.id }
            }),
          0
        );
      } else if (pass.pass_bucket && pass.pass_bucket.id) {
        setTimeout(
          () =>
            this.context.router.replace({
              pathname: `${prefix}/pass_buckets/${pass.pass_bucket.id}`,
              query: { highlight_pass: pass.id }
            }),
          0
        );
      } else {
        setTimeout(() => this.context.router.replace(`/welcome`), 0);
      }
    }
  }

  render() {
    return <WorkingIndicator fullPage={true} />;
  }
}

export default connectToStores(Pass);



// WEBPACK FOOTER //
// ./src/app/components/pass.jsx